<div class="robot-rules-container rate">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.message.title.condition" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_event" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              nzSize="large"
              [(ngModel)]="eventDay"
              [nzOptions]="listOfDayOption"
              [nzDropdownMatchSelectWidth]="false">
            </nz-select>
            <span class="node-type mx-[8px]">{{ "automation-edit_review_html_退房后" | translate }}</span>
            <nz-select
              nzSize="large"
              [(ngModel)]="eventTime"
              [nzOptions]="listOfTimeOption"
              [nzDropdownMatchSelectWidth]="false"
              [nzCustomTemplate]="formatTimeTpl">
            </nz-select>
            <ng-template #formatTimeTpl let-selected>
              <!-- 之所以加一个日期前缀，是因为 dateformat 接受的是一个有效的日期格式，仅有时间不是一个有效的格式，所以这里利用一个随机日期将其拼接完整 -->
              {{ "2023-11-11T" + selected.nzLabel | dateformat: [null, "hm"] }}
            </ng-template>
          </div>
          @if (eventDay < 1) {
            <div class="v4-layout-field-extra">
              {{ "automation-edit_review_html_zero_day_warn" | translate }}
              <!-- Consider selecting at least 1 day after check-out day , as the later the time, the higher the success rate
              of automatic review. -->
            </div>
          }
        </div>
      </div>
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="scopeChannels"
              (ngModelChange)="onSelectChannels($event)"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfChannelOption"></nz-select>
          </div>
        </div>
      </div>
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_channel_account" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-full placeholder-dark"
              nzSize="large"
              nzMode="multiple"
              [(ngModel)]="scopeAccounts"
              (ngModelChange)="onSelectAccounts($event)"
              [nzPlaceHolder]="'word.all' | translate"
              [nzOptions]="listOfChannelAccountOption"></nz-select>
          </div>
        </div>
      </div>

      <widget-rule-form-item-house-picker
        [data]="$any(scopeHouses)"
        (onChange)="scopeHouses = $event"></widget-rule-form-item-house-picker>

      <!-- nights -->
      <div class="v4-layout-field">
        <div class="v4-layout-field-label">
          {{ "automation-msg_rules_html_w_nights" | translate }}
          <!-- Nights -->
        </div>

        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <widget-nights [(value)]="nights"></widget-nights>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.rate.title.action" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.action.label_content" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row relative">
            <textarea
              #textarea
              class="pb-[40px]"
              rows="6"
              nz-input
              nzAutosize
              [placeholder]="'robot.rule.action.placeholder_content' | translate"
              [(ngModel)]="actionTextContent"
              [disabled]="actionQuickMsgId !== null"></textarea>
            <div class="absolute bottom-[1px] left-[10px] right-[20px] pb-[10px] bg-white">
              <host-dyn-content-picker
                [listOfDynContentOption]="listOfDynContentOption"
                (onSelect)="onSelectDynContent($event)"></host-dyn-content-picker>
            </div>
          </div>
          <div class="v4-layout-field-extra">
            <div class="w-[150px]">
              <host-rate-tpl-picker (onSelect)="onSelectQuickMsgOfAction($event)"></host-rate-tpl-picker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-row items-center justify-between pt-[30px]">
    <div class="left"></div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
      <button nz-button nzSize="large" nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
    </div>
  </div>
</div>
